import { gsap } from 'gsap';

function shouldReduceMotion() {
  if (document.documentElement.classList.contains('is-no-motion')) return true;

  return window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)')
    .matches;
}

function getCounterConfig(counter) {
  return {
    end: Number.parseFloat(counter.dataset.counterTo ?? '0'),
    fixed: Number.parseInt(counter.dataset.counterFixed ?? '0', 10),
    increment: Number.parseFloat(counter.dataset.counterIncrement ?? '1'),
    start: Number.parseFloat(counter.dataset.counterStart ?? '0'),
  };
}

function formatCounterValue(value, fixed) {
  if (fixed > 0) return value.toFixed(fixed);

  return Math.round(value).toString();
}

function setCounterValue(counter, value) {
  const { fixed } = getCounterConfig(counter);
  counter.textContent = formatCounterValue(value, fixed);
}

function animateCounter(counter, delay) {
  const config = getCounterConfig(counter);
  const state = { value: config.start };

  setCounterValue(counter, config.start);

  return gsap.to(state, {
    value: config.end,
    delay,
    duration: 0.75,
    ease: 'power1.out',
    onUpdate: () => {
      const snapped = gsap.utils.snap(config.increment, state.value);
      setCounterValue(counter, snapped);
    },
    onComplete: () => {
      setCounterValue(counter, config.end);
    },
  });
}

function animateCounters(parent) {
  const counters = parent.querySelectorAll('[data-counter-to]');
  if (!counters.length) return;

  if (shouldReduceMotion()) {
    counters.forEach((counter) => {
      const { end } = getCounterConfig(counter);
      setCounterValue(counter, end);
    });

    return;
  }

  counters.forEach((counter, index) => {
    animateCounter(counter, 0.9 + index * 0.1);
  });
}

export function initWllHero(parent) {
  if (!parent || parent.dataset.wllHeroAnimated === 'true') return;

  const start = () => {
    if (parent.dataset.wllHeroAnimated === 'true') return;

    parent.dataset.wllHeroAnimated = 'true';
    animateCounters(parent);
  };

  if (shouldReduceMotion() || !('IntersectionObserver' in window)) {
    start();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const hasVisibleEntry = entries.some((entry) => entry.isIntersecting);
      if (!hasVisibleEntry) return;

      observer.disconnect();
      start();
    },
    {
      threshold: 0.35,
    },
  );

  observer.observe(parent);
}

export function initAllWllHeroes(selector = '.js-wll-hero') {
  document.querySelectorAll(selector).forEach((hero) => initWllHero(hero));
}
